<template>
  <div class="row" id="providers">
    <v-row justify="center">
      <v-col cols="12" sm="12" md="10" lg="9">
        <v-form
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-container grid-list-xl>
            <form-toolbar :title="title" :loading="form.busy" @save="save" @cancel="cancel" />
            <v-layout :id="ref" class="wrap justify-space-around form-body">
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="form.ruc"
                  :rules="[rules.required, rules.rucLength, rules.rucFormat]"
                  label="Número de Documento"
                  maxlength="20"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn :color="themeColor">
                      <v-icon
                        @click="calcularDV"
                        v-on="on"
                      >mdi-account-search</v-icon>
                    </v-btn>
                  </template>
                  <span>Buscar</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.ruc_type"
                  :items="items_type"
                  :rules="[rules.required]"
                  label="Tipo de Contribuyente"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.dv"
                  :rules="[rules.required]"
                  label="Dígito Verificador"
                  maxlength="20"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.name"
                  :rules="[rules.required]"
                  label="Razón Social"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.email"
                  :rules="[rules.required, rules.emailFormat]"
                  label="Correo Electrónico"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.branch_code"
                  :rules="[rules.required, rules.numeric]"
                  label="Sucursal"
                  maxlength="10"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="form.cat_province_id"
                  :items="itemsProvince"
                  item-value="id"
                  item-text="name"
                  :rules="[rules.required]"
                  label="Provincia"
                  @change="getDistrito()"
                  required
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="form.cat_district_id"
                  :items="itemsDistrict"
                  item-value="id"
                  item-text="name"
                  :rules="[rules.required]"
                  label="Distrito"
                  @change="getCorregimiento()"
                  required
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="form.cat_corregimiento_id"
                  :items="itemsCorregimiento"
                  item-value="id"
                  item-text="name"
                  :rules="[rules.required]"
                  label="Corregimiento"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-model="form.address"
                  maxlength="100"
                  :rules="[rules.required]"
                  label="Dirección"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.phone"
                  :rules="[rules.required]"
                  label="Teléfono"
                  maxlength="12"
                  required
                ></v-text-field>
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from 'vform';
import FormToolbar from '~/components/Form/Toolbar';

export default {
  components: {
    FormToolbar,
  },
  computed: {
    ref() {
      return this.form.id;
    },
  },
  data: () => ({
    form: new Form({
      id: '',
      ruc: '',
      name: '',
      dv: '',
      ruc_group_dv: '1',
      ruc_type: '',
      email: '',
      phone: '',
      address: '',
      branch_code: '',
      cat_corregimiento_id: '',
      cat_district_id: '',
      cat_province_id: '',
      fel_id: '0',
      pac_id: '0',
      active: '1',
      busy: false,
    }),
    itemsProvince: [],
    itemsDistrict: [],
    itemsCorregimiento: [],
    items_type: [
      { value: 1, text: 'NATURAL' },
      { value: 2, text: 'JURÍDICO' },
    ],

    success: '',
    valid: false,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      rucLength: (v) => (v.length >= 5 && v.length <= 20) || 'El campo debe tener de 5 a 20 caracteres.',
      maxLength: (v) => v.length <= 11 || 'El campo debe tener menos de 10 caracteres.',
      numeric: (v) => /^[0-9]*$/.test(v) || 'El campo solo permite caracteres numericos.',
      emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
      rucFormat: (v) => /^(([P][E][-](([-]|[0-9]){1,17})|[N][-](([-]|[0-9]){1,18})|[E][-](([-]|[0-9]){1,18})|(([-]|[0-9]){5,20}))|(((([0-9]{1})[-][A][V][-](([-]|[0-9]){1,15}))|(([0-9]{2})[-][A][V][-](([-]|[0-9]){1,14})))|((([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,15}))|(([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,14}))|([N][T][-](([-]|[0-9]){1,14}))|(([0-9]{1,2})[-][P][I][-](([-]|[0-9]){1,14}))|([P][I][-](([-]|[0-9]){1,14}))|(([0-9]){1,2}[P][I][-](([-]|[0-9]){1,14})))))$/.test(v)
      || 'El campo debe tener un formato válido.',
    },
    buttons: [
      {
        icon: 'mdi-content-save',
        name: 'Guardar',
      },
      {
        icon: 'mdi-close',
        name: 'Cancelar',
      },
    ],
    title: 'Nueva Empresa',
    apiURL: '/api/enterprises/store',
    method: 'POST',
  }),

  props: {
    id: { default: '' },
    ruc: { default: '' },
  },
  watch: {
    'form.cat_province_id': {
      handler() {
        this.getDistrito();
      },
    },
    'form.cat_district_id': {
      handler() {
        this.getCorregimiento();
      },
    },
  },
  async mounted() {
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
    });
    if (this.id) {
      window.axios.get(`/api/enterprises/${this.id}`).then((result) => {
        Object.assign(this.form, result.data);
        this.apiURL = `/api/enterprises/${this.id}/update`;
        this.method = 'PUT';
        this.title = `Editar Empresa ${result.data.ruc} - ${result.data.name}`;
        this.message = `Se ha editado la empresa ${result.data.name} exitosamente.`;
      });
    }
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.store();
      }
    },
    store() {
      window
        .axios({
          method: this.method,
          url: this.apiURL,
          data: this.form,
        })
        .then((result) => {
          this.$router.push({
            name: 'enterprises',
            params: { action: 'created', message: result.data.message },
          });
        })
        .catch(() => {
          this.form.busy = false;
        });
    },
    save() {
      this.validate();
    },
    calcularDV() {
      if (this.form.ruc) {
        if (this.form.ruc_type === '') {
          this.errores = 'Seleccione un tipo de contribuyente';
        } else {
          const url = `/api/enterprises/getDV/${this.form.ruc}/${this.form.ruc_type}`;
          window.axios.post(url).then((response) => {
            if (response.data.codigo === '200') {
              this.form.dv = response.data.infoRuc.dv;
              this.form.name = response.data.infoRuc.razonSocial;
              this.success = 'SE RETORNA LOS DATOS DEL NÚMERO DE DOCUMENTO.';
            } else {
              this.success = '';
              this.form.dv = '';
              this.form.name = '';
              this.errores = response.data.mensaje;
            }
          });
        }
      } else {
        this.errores = 'Introduzca un número de identificación';
      }
    },
    cancel() {
      this.$router.go(-1);
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    getProvincia() {
      const url = '/api/provinces';
      return window.axios.get(url);
    },
    getDistrito() {
      if (this.form.cat_province_id) {
        const url = `/api/districts/${this.form.cat_province_id}`;
        window.axios.get(url).then((response) => {
          this.itemsDistrict = response.data;
        });
      }
    },
    getCorregimiento() {
      if (this.form.cat_district_id) {
        const url = `/api/corregimientos/${this.form.cat_district_id}`;
        window.axios.get(url).then((response) => {
          this.itemsCorregimiento = response.data;
        });
      }
    },
  },
};
</script>
